const Notfound = () => <div> Not found</div>;

export default Notfound;
